import React from 'react'
import s from '@commonStyles/footer/Footer.module.scss'
import { AlfaRichContent as RichContent } from '@components/alfakher/pylot-rich-content'
import { Newsletter } from '@corratech/pylot-footer-newsletter'
import { NavigationResponse } from '@pylot-data/hooks/cms/use-cms-blocks'
import { Maybe, CmsBlock } from '@pylot-data/fwrdschema'
import { useStoreConfig } from '@config/hooks/useStoreConfig'
import cn from 'classnames'
import { usePreloadedData } from '@preload'
import { FOOTER_CMS_BLOCKS } from '@config/preload'

const Footer = (): JSX.Element | null => {
    const config = useStoreConfig()
    const { footer: { role } = {} } = config.preload
    const {
        data: {
            cmsBlocks: { items }
        }
    } = (usePreloadedData(FOOTER_CMS_BLOCKS) as unknown) as {
        data: { cmsBlocks: NavigationResponse }
    }

    if (!items || !role) {
        return null
    }

    const mappedItems: Record<string, Maybe<CmsBlock>> = {}
    items.forEach((item) => {
        if (item && item.identifier && item.content) {
            mappedItems[item.identifier] = item
        }
    })

    const getBlockOutput = (identifier?: string | null, className?: string) => {
        return (
            identifier &&
            mappedItems[identifier] && (
                <div className={className ? s[className] : ''}>
                    <RichContent html={mappedItems[identifier]?.content} />
                </div>
            )
        )
    }

    return (
        <footer className={s.footer}>
            <div className={s['footer-container']}>
                <div className={s['footer-value-prop-row']}>
                    {getBlockOutput(role.unique)}
                </div>
                <div className={s['grid-rows']}>
                    <div className={s['grid-col-1']}>
                        <div className={s['footer-links']}>
                            {getBlockOutput(role.links)}
                        </div>
                        <div className={cn(s['copyright'], s['copyright-mob'])}>
                            {getBlockOutput(role.copyright)}
                        </div>
                    </div>
                    <div className={s['grid-col-2']}>
                        <Newsletter />
                        {getBlockOutput(role.social, 'social-icons')}
                        <div className={s['footer-copyright-block']}>
                            {getBlockOutput(role.social, 'social')}

                            <div className={s['copyright']}>
                                {getBlockOutput(role.copyright)}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    )
}

export default Footer
